import { formatDate } from "@angular/common";
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Type,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import { toUpper } from "lodash";

@Component({
  selector: "app-admin-create-workorder",
  templateUrl: "./admin-create-workorder.component.html",
  styleUrls: ["./admin-create-workorder.component.css"],
})
export class AdminCreateWorkorderComponent implements OnInit {
  workorderForm: FormGroup;
  enabledetails: boolean = false;
  dropAutoComplete: any;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  completeDropAddress: any;
  completePickUpAddress: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  drop_long_name: any = "";
  drop_short_name: any = "";
  pickup_postal_code: any;
  dropoff_postal_code: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truckCategory: any = [];
  loadCategory: any;
  token: any;
  loadCategorySelectedindex: any;
  loadSelectedCategory: any;
  materialDetails: any;
  otherValue: any;
  customerName: any = [];
  corporate_name: any = [];
  workorderArray: any;
  vehicleArray: any;
  unloadingQty: any;
  loadingQty: any;
  selectedWorkOrderQty: any;
  total_quantity: any;
  work_order_msg: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  selectCatgValue: any;
  vehiclelists: any;
  truckArray: any;
  work_order_qty: any;
  workOrderQnty: any;
  selectedLoadedQuantity: any;
  perPage: any = 99999;
  startPage: any = 1;
  searchLoadType: any = -1;
  page: any = 1;
  searchEmployeeName: any = -1;
  employeeStartPage: any = 1;
  employeeName: any = [];
  customerMobile = -1;
  activeCorporateList: any = [];
  corporate: any;
  materialTypeSelected: boolean = false;
  pickupPlace: any;
  dropPlace: any;
  loading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminCreateWorkorderComponent>,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.maxDate.setDate(this.maxDate.getDate() + 0);
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.GetCategory();
    this.getLoadDetails();
    this.getCustomerList();
    this.getworkOrder();
    this.employeeGet(this.searchEmployeeName);
    this.workorderForm = this.formBuilder.group({
      from_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      to_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      pickup_date: [""],
      truck_category: ["", [Validators.required]],
      total_tons: ["", Validators.compose([Validators.required])],

      price_per_ton: ["", Validators.compose([Validators.required])],
      material_type: ["", Validators.compose([Validators.required])],

      username: ["", Validators.required],
      pickup_name: ["", [Validators.required]],
      address_line: ["", Validators.compose([Validators.required])],
      pickup_contact: [
        "",
        Validators.required,
        Validators.compose([Validators.pattern("^[0-9]{4,10}$")]),
      ],
      city: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],

      dropoff_name: ["", [Validators.required]],
      state: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      pincode: ["", [Validators.required, Validators.pattern("^[0-9]{6,6}$")]],
      dropoff_contact: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],
      email: ["", [Validators.email]],
      pay_as_load_quantity: ["", [Validators.required]],
    });
  }

  getCustomerList() {
    this.services
      .getUsersCustomers(
        this.token,
        this.perPage,
        this.startPage,
        this.customerMobile
      )
      .subscribe(
        (response: any) => {
          let customerdata: any;
          customerdata = response.body.data;
          for (var i = 0; i < customerdata.length; i++) {
            if (customerdata[i].user_type == "corporate") {
              this.corporate_name.push(customerdata[i]);
              this.filterActiveCorporates(this.corporate_name);
            }
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  filterActiveCorporates(corporate_name: any) {
    this.activeCorporateList = corporate_name.filter(
      (corporate: any) => corporate.login_status === "active"
    );
    return this.activeCorporateList;
  }
  close() {
    this.matdialogref.close();
  }

  ngAfterViewInit(): void {
    var options = {
      componentRestrictions: { country: "in" },
    };
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );
  }

  onInputPickUpchange() {
    this.geoCodePickUp(this.workorderForm.value.pickup);
    this.checkLocations();
  }
  public get ProfileFormControl() {
    return this.workorderForm.controls;
  }
  public get contactFormControl() {
    return this.workorderForm.controls;
  }
  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        this.pickupPlace = place;
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              this.autoCompletePickupGeoCode(geoCoder, latlong);

              this.workorderForm.controls["from_area_name"].setValue(
                place.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }
  autoCompletePickupGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any) => {
      this.completePickUpAddress = result[0];
      for (
        let i = 0;
        i < this.completePickUpAddress.address_components.length;
        i++
      ) {
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
          "locality" &&
          this.completePickUpAddress.address_components[i].types[1] ==
          "political"
        ) {
          {
            this.pickup_short_name =
              this.completePickUpAddress.address_components[i].long_name;
          }
        }
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
          "political" &&
          this.completePickUpAddress.address_components[i].types[1] ==
          "sublocality" &&
          this.completePickUpAddress.address_components[i].types[2] ==
          "sublocality_level_1"
        ) {
          this.pickup_long_name =
            this.completePickUpAddress.address_components[i].long_name;
        }
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
          "postal_code"
        ) {
        }
        if (this.pickup_short_name && this.pickup_long_name) {
        }
      }
    });
  }

  employeeGet(item: any) {
    this.services
      .getUsersEmployees(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.employeeStartPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.employeeName = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        this.dropPlace = dropPlace;

        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },

          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              this.autoCompleteDropGeoCode(geoCoder, latlong);

              this.workorderForm.controls["to_area_name"].setValue(
                dropPlace.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }
  autoCompleteDropGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any) => {
      this.completeDropAddress = result[0];
      for (
        let i = 0;
        i < this.completeDropAddress.address_components.length;
        i++
      ) {
        if (
          this.completeDropAddress.address_components[i].types[0] ==
          "locality" &&
          this.completeDropAddress.address_components[i].types[1] == "political"
        ) {
          this.drop_short_name =
            this.completeDropAddress.address_components[i].long_name;
        }
        if (
          this.completeDropAddress.address_components[i].types[0] ==
          "political" &&
          this.completeDropAddress.address_components[i].types[1] ==
          "sublocality" &&
          this.completeDropAddress.address_components[i].types[2] ==
          "sublocality_level_1"
        ) {
          this.drop_long_name =
            this.completeDropAddress.address_components[i].long_name;
        }
        if (
          this.completeDropAddress.address_components[i].types[0] ==
          "postal_code"
        ) {
        }
      }
    });
  }
  onDropChange() {
    this.geoCodeDrop(this.workorderForm.value.drop);
    this.checkLocations();
  }
  checkLocations() {
    const pickup = this.workorderForm.value.from_area_name
      ?.toLowerCase()
      .trim();
    const drop = this.workorderForm.value.to_area_name?.toLowerCase().trim();
    if (pickup && drop && pickup === drop) {
      this.snackBar.open(
        "Pickup and Drop Off locations cannot be the same",
        "Fail",
        { duration: 5000 }
      );
    }
    return;
  }
  public GetCategory() {
    this.services
      .GetCategory(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.truckCategory = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  getLoadDetails() {
    this.services
      .GetLoadDetails(this.token, this.searchLoadType, this.perPage, this.page)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loadCategory = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  public loadCatChange(category: any, index: any) {
    this.materialDetails = "";
    this.loadSelectedCategory = category;
    this.loadCategorySelectedindex = index;
    this.materialDetails = this.loadCategory.find((ele: any) => {
      return ele.load_category === category;
    });
    if (this.materialDetails?.material_type == 0) {
      this.snackBar.open("Material type not found..", "Fail", {
        duration: 5000,
      });
    }
  }

  getCustomer(item: any) {
    this.customerName = this.corporate_name.filter((ele: any) => {
      return ele._id == item.value;
    });

    if (this.customerName.length > 0) {
      const billingAddress = this.customerName[0]?.userInfo?.[0]?.billing_address;
      if (billingAddress) {
        this.workorderForm.patchValue({
          username: billingAddress.username || "",
          email: billingAddress.email || "",
          address_line: billingAddress.address_line || "",
          city: billingAddress.city || "",
          state: billingAddress.state || "",
          pincode: billingAddress.pincode || "",
          gst: billingAddress.gst || "",
        });
      }
    }
  }
  createWorkOrder(event: any) {
    // if (!this.workorderForm.valid || this.loading) {
    //   return; // 🚀 Prevent clicks if already loading
    // }
    this.loading = true; // ✅ Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly
    const pickups = this.workorderForm.get("from_area_name")?.value;
    const dropup = this.workorderForm.get("to_area_name")?.value;
    if (pickups && dropup && pickups === dropup) {
      this.snackBar.open(
        "Pick-up and Drop-off locations should not be the same",
        "Fail",
        { duration: 5000 }
      );
      return;
    }

    // Check if the form is invalid
    if (this.workorderForm.invalid) {
      this.snackBar.open("Please fill all the mandatory fields", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (
      this.workorderForm.value.dropoff_contact == "" ||
      this.workorderForm.value.dropoff_contact == null
    ) {
      this.snackBar.open("Please fill all the mandatory fields", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      (event.target as HTMLButtonElement).disabled = false;
      return;
    }
    if (
      this.workorderForm.value.pay_as_load_quantity == "" ||
      this.workorderForm.value.pay_as_load_quantity == null
    ) {
      this.snackBar.open("Please fill all the mandatory fields", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      (event.target as HTMLButtonElement).disabled = false;
      return;
    }
    if (
      this.workorderForm.value.total_tons == "" ||
      this.workorderForm.value.total_tons == null
    ) {
      this.snackBar.open("Please fill all the mandatory fields", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      (event.target as HTMLButtonElement).disabled = false;
      return;
    }
    if (
      this.workorderForm.value.material_type == "" ||
      this.workorderForm.value.material_type == null
    ) {
      this.snackBar.open("Please fill all the mandatory fields", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      (event.target as HTMLButtonElement).disabled = false;
      return;
    }

    if (
      this.workorderForm.value.price_per_ton == "" ||
      this.workorderForm.value.price_per_ton == null
    ) {
      this.snackBar.open("Please fill all the mandatory fields", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      (event.target as HTMLButtonElement).disabled = false;
      return;
    }
    if (
      this.workorderForm.value.truck_category == null ||
      this.workorderForm.value.truck_category == ""
    ) {
      this.snackBar.open("Please fill all the mandatory fields", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      (event.target as HTMLButtonElement).disabled = false;
      return;
    }

    // If the form is valid, proceed to create the work order
    const workOrder = {
      from_complete_address: this.pickupPlace?.formatted_address,
      pickup_details: {
        from_area_name: this.pickup_long_name,
        from_city_name: this.pickup_short_name,
        from_lat: (Math.round(this.pickupLat * 10000) / 10000).toString(),
        from_long: (Math.round(this.pickupLong * 10000) / 10000).toString(),
      },
      to_complete_address: this.dropPlace?.formatted_address,
      dropoff_details: {
        to_area_name: this.drop_long_name,
        to_city_name: this.drop_short_name,
        to_lat: (Math.round(this.dropLat * 10000) / 10000).toString(),
        to_long: (Math.round(this.dropLong * 10000) / 10000).toString(),
        to_pincode: this.dropoff_postal_code,
      },
      pickup_date: formatDate(
        this.workorderForm.value.pickup_date,
        "yyyy-MM-dd",
        "en"
      ),
      truck_category: this.workorderForm.value.truck_category,
      total_tons: Number(this.workorderForm.value.total_tons),
      price_per_ton: Number(this.workorderForm.value.price_per_ton),
      load_type: this.loadSelectedCategory,
      material_type: this.workorderForm.value.material_type,
      billing_address: {
        username: this.workorderForm.value.username,
        email: this.workorderForm.value.email,
        address_line: this.workorderForm.value.address_line,
        city: this.workorderForm.value.city,
        state: this.workorderForm.value.state,
        pincode: this.workorderForm.value.pincode,
        gst: toUpper(this.workorderForm.value.gst),
      },
      pickup_contact: Number(this.workorderForm.value.pickup_contact),
      pickup_name: this.workorderForm.value.pickup_name,
      dropoff_contact: Number(this.workorderForm.value.dropoff_contact),
      dropoff_name: this.workorderForm.value.dropoff_name,
      terms_and_conditions: true,
      pay_as_load_quantity: this.selectedLoadedQuantity,
      payment_mode: "offline",
      user_id: this.customerName[0]?._id,
    };

    if (workOrder.total_tons === 0) {
      this.snackBar.open("The Total tonnage cannot be zero", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      (event.target as HTMLButtonElement).disabled = false;
      return;
    }
    if (workOrder.price_per_ton === 0) {
      this.snackBar.open("Price per ton cannot be zero", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      (event.target as HTMLButtonElement).disabled = false;
      return;
    }
    this.services.createWo(workOrder, this.token).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.matdialogref.close({ event: "Success" });
          this.snackBar.open("Workorder created successfully", "Success", {
            duration: 5000,
          });
          this.getworkOrder();
        }
        setTimeout(() => {
          this.loading = false; // ✅ Enable button after response
          (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
        }, 500);
      },
      (error) => {
        if (
          error.error.message === "jwt malformed" ||
          error.error.message === "jwt expired" ||
          error.error.message === "invalid signature"
        ) {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        this.snackBar.open(
          error.error.message || "Failed to create workorder",
          "Fail",
          {
            duration: 5000,
          }
        );
        this.loading = false;
        (event.target as HTMLButtonElement).disabled = false;
      }
    );
  }

  public getVehiclesList(item: any) {
    this.selectCatgValue = item.value;
    this.services.GetVehicle(this.selectCatgValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.vehiclelists = response.body.data;
          this.workorderForm.patchValue({
            driver_no: this.vehiclelists?.driverInfo[0]?.mobile,
            driver_id: this.vehiclelists?.driverInfo[0]?.username,
            truck_no: this.vehiclelists?.truckOwnerInfo[0]?.mobile,
            truck_name: this.vehiclelists?.truckOwnerInfo[0]?.username,
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  selectLoadedQty(selectedValue: any) {
    this.selectedLoadedQuantity = selectedValue;
  }

  // getVehicleList() {
  //   this.services.vehicleList(this.token).subscribe(
  //     (response: any) => {
  //       this.truckArray = response.body.data;
  //     },
  //     (error) => {
  //       if (error.error.message === "jwt malformed") {
  //         this.router.navigateByUrl("admin/login");
  //         window.localStorage.clear();
  //       }
  //       if (error.error.message === "jwt expired") {
  //         this.router.navigateByUrl("admin/login");
  //         window.localStorage.clear();
  //       }
  //       if (error.error.message === "invalid signature") {
  //         this.router.navigateByUrl("admin/login");
  //         window.localStorage.clear();
  //       }
  //       this.snackBar.open(error.error.message, "Fail", {
  //         duration: 5000,
  //       });
  //     }
  //   );
  // }

  remainingQnty(event: any) {
    this.workOrderQnty = event.target.value;
    this.work_order_qty = this.total_quantity - this.workOrderQnty;
    if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
      this.workorderForm.patchValue({
        remaining_tons: this.total_quantity - this.workOrderQnty,
      });
    } else {
      this.workorderForm.patchValue({
        remaining_tons: this.total_quantity,
      });
      this.snackBar.open(
        "Work Order Quantity Should not Exceed With Remaining Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
    }
  }

  getworkOrder() {
    this.services.ListWorkOrder(this.token).subscribe(
      (response: any) => {
        this.vehicleArray = response.body.data;
        this.workorderArray = response.body;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close({ event: "Success" });
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }

  selectChangeHandler(item: any) {
    this.selectedWorkOrderQty = item;
    this.work_order_msg = item.workorder_id;
    let _id = this.workorderForm.value.work_order;
    this.services
      .selectedWorkOrder(_id, this.token)
      .subscribe((response: any) => {
        this.workorderForm.patchValue({
          act_ton: response.body.data.price_per_ton,
          work_date: this.formatFormDate(response.body.data.createdAt),
        });
        this.total_quantity = response.body.data.remaining_tons;
      });
    this.workorderForm.get("remaining_tons")?.patchValue(item.remaining_tons);
    this.workorderForm.get("total_tons")?.patchValue(item.total_tons);

    if (item.pay_as_load_quantity === "unloaded_quantity") {
      this.unloadingQty = "unloaded_quantity";
      this.workorderForm.controls["loading_point"].disable();
      this.workorderForm.controls["loading_point"].reset();
      this.workorderForm.controls["unloading_point"].enable();
    } else {
      this.workorderForm.controls["unloading_point"].disable();
      this.workorderForm.controls["unloading_point"].reset();
      this.workorderForm.controls["loading_point"].enable();
      this.loadingQty = "loading_point";
    }
  }
  clearPickUpField() {
    this.workorderForm.controls["from_area_name"].setValue("");
  }
  clearDropUpField() {
    this, this.workorderForm.controls["to_area_name"].setValue("");
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
